import React from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";

import SocialGrid3 from './SocialGrid3';
import StateFactory from '../StateFactory';
import SocialGrid3State from "./SocialGrid3State";
import ScreenService from "../../services/ScreenService";

class SocialGrid3SmallState extends SocialGrid3State {

    get name() {
        return 'socialgrid3small';
    }

    _render(resolve) {
        ReactDOM.render(
            <SocialGrid3
                content={this.state.state.contentArr}
                onMounted={this.onSocialGridMounted}
                playing={false}
                onError={this.raiseError}
                duration={this.state.duration}
                maxBoxSize={3}
                columns={5}
                rows={3}
                shouldTileFlip={false}
                relaxed={true}
            />,
            this.node
        );
    }

    static appliesTo(meta, node, state) {
        const { model } = meta;
        const isNotXumo = model.toLowerCase() !== 'xumo';
        //only applies if screen is *not* vertical and layout is explicitly set as 'relaxed' and is not a Xumo device
        return !ScreenService.isVertical && _.get(state, 'state.layout') === 'relaxed' && isNotXumo;
    }
}

StateFactory.register('socialgrid', SocialGrid3SmallState, 1);

export default SocialGrid3SmallState;
